import { render, staticRenderFns } from "./SynergismDimensionBoostRow.vue?vue&type=template&id=440f8a9a&"
import script from "./SynergismDimensionBoostRow.vue?vue&type=script&lang=js&"
export * from "./SynergismDimensionBoostRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports